import { useEffect } from "react";

import AccessDenied from "components/AccessDenied";
import useAuthorized from "hooks/useAuthorized";
import { storeForbiddenError } from "services/helpers";

// The fallback of a route guard. Each permission the user lacks is recorded
// on the error store, which ErrorModal lists, so the user can tell an admin
// which grant is missing.
const ForbiddenRoute = ({ permissions, partialMatch = false }) => {
  const { grantedInfo } = useAuthorized(permissions, {
    partialMatch,
    shouldReturnGrantedInfo: true,
  });

  // grantedInfo is rebuilt on every render, so the effect keys on the joined
  // items; otherwise a re-render would reopen an ErrorModal the user closed.
  const deniedKey = grantedInfo
    .filter(({ granted }) => !granted)
    .map(({ method, path }) => `${method.toUpperCase()} - ${path}`)
    .join("\n");

  useEffect(() => {
    if (!deniedKey) return;
    deniedKey.split("\n").forEach(storeForbiddenError);
  }, [deniedKey]);

  return <AccessDenied />;
};

export default ForbiddenRoute;
